import type { SubscriptionAction } from './getSubscriptionAction';
import { isCorePlan } from './isCorePlan';

export type PaymentAction = Extract<SubscriptionAction, 'new' | 'upgrade' | 'downgrade'>;

type TextKeyFn = (isCore: boolean, hasIntroductoryPrice: boolean) => string;

/**
 * Payment 모달에서 결제 버튼의 번역키를 반환한다.
 *
 * [구독 없음]
 * - Core 결제: 구독하기
 * - Max 결제: 구독하기
 *
 * [구독 없음 + 인트로 가격]
 * - Core 결제: 첫 구독 할인 받기
 * - Max 결제: 첫 구독 할인 받기
 *
 * [Core → Max 업그레이드]
 * - Max 결제: 구독 플랜 변경하기
 *
 * [Max renew off → Core 다운그레이드]
 * - Core 결제: 구독 플랜 변경하기
 */
const TEXT_KEYS: Record<PaymentAction, TextKeyFn> = {
  new: (isCore, hasIntroductoryPrice) => {
    if (hasIntroductoryPrice) return 'shop.subs_purchase_modal_introductory_price';
    return isCore ? 'subs_core_plan_modal_cta' : 'subs_max_plan_modal_cta';
  },
  upgrade: () => 'subs_max_crossgrade_cta',
  downgrade: () => 'subs_core_crossgrade_cta',
};

export const getPaymentButtonTextKey = (
  action: PaymentAction,
  planId: string,
  hasIntroductoryPrice: boolean
): string => {
  return TEXT_KEYS[action](isCorePlan(planId), hasIntroductoryPrice);
};
